/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
// import { connect } from 'react-redux';
import { AccountList, FAQs } from '../../../assets/constants/strings';
import $ from 'jquery';

import './style.scoped.scss';
import '../text_wrapper.scss';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import config from '../../../config';

// handleSetFAQ
const Assistance = ({ handleSetFAQ }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [accountCollapsed, setAccountCollapsed] = useState(true);

  const handleArrowClick = (current) => {
    $(`#FAQList`).collapse('toggle');
    setIsCollapsed(!current);
  };

  const handleArrowClickAccount = (current) => {
    $(`#AccountList`).collapse('toggle');
    setAccountCollapsed(!current);
  };

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip();
  });

  return (
    <div key='wf-Assistance-Items' id='wf-Assistance-Items'>
      <p className='m-0'>
        <a
          href={`${config.WordPressURL}help`}
          target='_blank'
          rel='noreferrer'
          className='wf-card__item wf-card__item--clickable'
        >
          Help
        </a>
      </p>
      {/* <a
        href="https://regulationcityhelp.zendesk.com/hc/en-us"
        target="_blank"
        rel="noreferrer"
        className="wf-card__item wf-card__item--clickable"
      >
        FAQs
      </a> */}
      {/* <p className='m-0 mt-1 mb-1'>
        <a
          href='https://youtu.be/kZjehqI7JWs'
          target='_blank'
          rel='noreferrer'
          className='wf-card__item wf-card__item--clickable'
        >
          Take a tour
        </a>
      </p> */}
      <p className='m-0'>
        <a
          href={`${config.WordPressURL}comments-suggestions`}
          target='_blank'
          rel='noreferrer'
          className='wf-card__item wf-card__item--clickable'
        >
          Comments and Suggestions
        </a>
      </p>
      <div id='FAQItemsGroup' key='FAQItemsGroup'>
        <a role='button' onClick={() => handleArrowClick(isCollapsed)}>
          <div className='d-flex justify-content-between p-1 hover'>
            <p className='m-0'>FAQs</p>
            {isCollapsed ? <FaAngleDown /> : <FaAngleUp />}
          </div>
        </a>
        <div id='FAQList' className='collapse' data-parent='#FAQItemsGroup'>
          <div className='d-flex flex-column pl-2'>
            {FAQs.map((question, i) =>
              question.isAccount === false ? (
                <div
                  key={i}
                  className='wf-card__item__wrapper'
                  onClick={() => handleSetFAQ(question.NUMBER)}
                >
                  <p title={question.TITLE}>{question.TITLE}</p>
                </div>
              ) : (
                <div id='ManageAccountGroup' key='ManageAccountGroup'>
                  <a
                    role='button'
                    onClick={() => handleArrowClickAccount(accountCollapsed)}
                  >
                    <div className='d-flex justify-content-between p-1 hover'>
                      <p className='m-0'>
                        <b>How to Manage Your Account</b>
                      </p>
                      {accountCollapsed ? <FaAngleDown /> : <FaAngleUp />}
                    </div>
                  </a>
                  <div
                    id='AccountList'
                    className='collapse'
                    data-parent='#ManageAccountGroup'
                  >
                    <div className='d-flex flex-column pl-2'>
                      {AccountList.map((account, i) => (
                        <div
                          key={i}
                          className='wf-card__item__wrapper'
                          onClick={() => handleSetFAQ(account.NUMBER)}
                        >
                          <p title={account.TITLE}>{account.TITLE}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// const mapStateToProps = (state) => ({
//   isPreview: state.client.isPreview,
// });

// const connector = connect(mapStateToProps, null);

// export default connector(Assistance);
export default Assistance;
